import cx from 'classnames';
import Icon from '@components/common/Icon'

export const SelectedCreditCard = ( {cardType} ) => {
    const getItemClass = a => b => {
        return cx( 'credit-card-list-item w-10 md:w-16', {
            'is-selected': a === b,
            'is-hidden': b && b !== a
        } );
    };

    return (<div className="card-field card-field--cardlist h-6 relative">
            <ul className="credit-cards credit-card-list absolute pin-b">
                <li className={getItemClass( 'visa' )( cardType )}>
                    <i className="icon-visa"></i>
                </li>
                <li className={getItemClass( 'mastercard' )( cardType )}>
                    <i className="icon-mastercard"></i>
                </li>
                <li className={getItemClass( 'amex' )( cardType )}>
                    <i className="icon-amex"></i>
                </li>
                <li className={getItemClass( 'discover' )( cardType )}>
                    <i className="icon-discover"></i>
                </li>
            </ul>
        </div>);
};

export const SelectedCreditCardCVV = ( {cardType} ) => {
    const itemClasses = 'cvv-display-item leading-none lg:leading-tight';
    return (<ul style="margin-top:1.25rem" className="credit-card-cvvdisplay list-reset ml-2 pl-20 pointer-events-none">
            <li className={cx( itemClasses, {
                'is-hidden': ['amex'].includes( cardType )
            } )}>
                <small className="text-xs font-bold md:block">3 digits back</small>
                <Icon.ui name="credit-card-back" className="block text-2xl"/>
            </li>
            <li className={cx( itemClasses, {
                'is-hidden': !['amex'].includes( cardType )
            } )}>
                <small className="text-xs font-bold md:block">4 digits front</small>
                <Icon.ui name="credit-card-front" className="block text-2xl"/>
            </li>
        </ul>);
};